import {markdown, markdownLanguage} from '@codemirror/lang-markdown';
import type {
  Language,
  LanguageDescription,
  LanguageSupport,
} from '@codemirror/language';

interface MarkdownGfmConfig {
  codeLanguages?:
    | readonly LanguageDescription[]
    | ((info: string) => Language | LanguageDescription | null);
  defaultCodeLanguage?: Language | LanguageSupport;
  addKeymap?: boolean;
}

// GitHub-Flavored Markdown wrapper around @codemirror/lang-markdown.
// markdownLanguage is GFM (strikethrough, tables, task lists, autolinks) plus
// subscript/superscript/emoji shortcode parsing. The extras are highlighting-
// only — they don't change the stored bytes — and our decoration plugin opts
// into specific node types, so unhandled extras render as literal characters.
export function markdownGfm(config: MarkdownGfmConfig = {}) {
  return markdown({
    base: markdownLanguage,
    ...config,
  });
}
